const C = {
  name: "Cloud",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.5 6C13.9897 6 12.6696 6.83781 11.9881 8.08846L11.475 9.03025L10.5713 8.45252C10.1223 8.16542 9.57922 8 9 8C7.34228 8 6 9.34228 6 11V12H5C3.34228 12 2 13.3423 2 15C2 16.6577 3.34228 18 5 18H19C20.6577 18 22 16.6577 22 15C22 13.6951 21.1684 12.5875 20.011 12.1843L19.1278 11.8766L19.3758 10.9748C19.4594 10.6708 19.5 10.3509 19.5 10C19.5 7.79228 17.7077 6 15.5 6ZM10.7619 6.32184C11.8604 4.90694 13.576 4 15.5 4C18.8123 4 21.5 6.68772 21.5 10C21.5 10.22 21.4889 10.4383 21.4653 10.6553C22.98 11.5084 24 13.1357 24 15C24 17.7623 21.7623 20 19 20H5C2.23772 20 0 17.7623 0 15C0 12.5507 1.75933 10.5139 4.0837 10.0837C4.51385 7.75933 6.55071 6 9 6C9.61411 6 10.2103 6.11218 10.7619 6.32184Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Cloud
};
